module.exports = __webpack_public_path__ + "media/images/donation-popup-logo-724853f872ad0ef70e10630ff4f767ef.svg";